/** @format */

export const js = [
  {
    title: 'Модуль 1',
    path: '/js/1',
    items: [
      { title: 'Что такое JavaScript?', path: '/js/1/1' },
      { title: 'Подключение скрипта', path: '/js/1/2' },
      { title: 'Вкладка Console в Chrome DevTools', path: '/js/1/3' },
      { title: 'Синтаксис', path: '/js/1/4' },
      { title: 'Переменные и типы данных', path: '/js/1/5' },
      { title: 'Взаимодействие с пользователем', path: '/js/1/6' },
      { title: 'Основные операторы', path: '/js/1/7' },
      { title: 'Числа', path: '/js/1/8' },
      { title: 'Строки', path: '/js/1/9' },
      { title: 'Логические операторы', path: '/js/1/10' },
      { title: 'Ветвления', path: '/js/1/11' },
      { title: 'Область видимости', path: '/js/1/12' },
      { title: 'Циклы', path: '/js/1/13' },
    ],
  },
  {
    title: 'Модуль 2',
    path: '/js/2',
    items: [
      { title: 'Массивы', path: '/js/2/1' },
      { title: 'Присвоение по ссылке и по значению', path: '/js/2/2' },
      { title: 'Методы массива', path: '/js/2/3' },
      { title: 'Функции', path: '/js/2/4' },
      { title: 'Область видимости', path: '/js/2/5' },
      { title: 'Стрелочные функции', path: '/js/2/6' },
      { title: 'Домашнее задание', path: '/js/2/7' },
    ],
  },
  {
    title: 'Модуль 3',
    path: '/js/3',
    items: [
      { title: 'Объекты', path: '/js/3/1' },
      { title: 'Перебор объекта', path: '/js/3/2' },
      { title: 'Операции spread и rest', path: '/js/3/3' },
      { title: 'Деструктуризация', path: '/js/3/4' },
    ],
  },
  {
    title: 'Модуль 4',
    path: '/js/4',
    items: [
      { title: 'Функции обратного вызова', path: '/js/4/1' },
      { title: 'Стек вызовов и лексическое окружение', path: '/js/4/2' },
      { title: 'Замыкания', path: '/js/4/3' },
      { title: 'Ключевое слово this', path: '/js/4/4' },
    ],
  },
  {
    title: 'Модуль 5',
    path: '/js/5',
    items: [
      { title: 'ООП', path: '/js/5/1' },
      { title: 'Конструкторы', path: '/js/5/2' },
      { title: 'Прототипы', path: '/js/5/3' },
      { title: 'ES6 классы', path: '/js/5/4' },
    ],
  },
  {
    title: 'Модуль 6',
    path: '/js/6',
    items: [
      { title: 'Императивный и декларативный код', path: '/js/6/1' },
      { title: 'Чистые функции', path: '/js/6/2' },
      { title: 'Перебирающие методы массива', path: '/js/6/3' },
    ],
  },
  {
    title: 'Модуль 7',
    path: '/js/7',
    items: [
      { title: 'Объектная модель документа', path: '/js/7/1' },
      { title: 'Навигация по DOM', path: '/js/7/2' },
      { title: 'DOM-свойства и атрибуты', path: '/js/7/3' },
      { title: 'Создание и удаление узлов', path: '/js/7/4' },
      { title: 'События', path: '/js/7/5' },
      { title: 'Процесс построения веб-страницы', path: '/js/7/6' },
    ],
  },
  {
    title: 'Модуль 8',
    path: '/js/8',
    items: [
      { title: 'Распространение. Всплытие. Делегирование', path: '/js/8/1' },
      { title: 'Throttle и Debounce', path: '/js/8/2' },
      { title: 'IntersectionObserver API', path: '/js/8/3' },
    ],
  },
  {
    title: 'Модуль 9',
    path: '/js/9',
    items: [
      { title: 'Node.js', path: '/js/9/1' },
      { title: 'NPM', path: '/js/9/2' },
      { title: 'Модульность кода', path: '/js/9/3' },
      { title: 'Webpack', path: '/js/9/4' },
    ],
  },
  {
    title: 'Модуль 10',
    path: '/js/10',
    items: [
      { title: 'Плагины и библиотеки', path: '/js/10/1' },
      { title: 'JSON', path: '/js/10/2' },
      { title: 'Хранение информации на клиенте', path: '/js/10/3' },
    ],
  },
  {
    title: 'Модуль 11',
    path: '/js/11',
    items: [
      { title: 'Асинхронный JavaScript', path: '/js/11/1' },
      { title: 'Класс Date', path: '/js/11/2' },
      { title: 'Promise API', path: '/js/11/3' },
      { title: 'Цикл событий', path: '/js/11/4' },
    ],
  },
  {
    title: 'Модуль 12',
    path: '/js/12',
    items: [
      { title: 'Протоколы передачи данных', path: '/js/12/1' },
      { title: 'REST API', path: '/js/12/2' },
      { title: 'AJAX и Fetch API', path: '/js/12/3' },
      { title: 'Кроссдоменные запросы', path: '/js/12/4' },
      { title: 'CRUD', path: '/js/12/5' },
      { title: 'Асинхронные функции', path: '/js/12/6' },
    ],
  },
]
